import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setReorderIds } from "../../../store/mods_factory/categoriesSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Sortable from "../../../componets/Sortable";
import { reorderCategories } from "../../../actions/mods_factory/categoriesActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.modsFactory.categories.reorderIds);
  const reorderParentId = useAppSelector(state => state.modsFactory.categories.reorderParentId);
  const categories = useAppSelector(state => state.modsFactory.categories.entities);

  function onClose() {
    dispatch(setReorderIds({ ids: null }));
  }

  function onClickSave(ids: any[]) {
    dispatch(reorderCategories({ ids, reorderParentId }));
    onClose();
  }

  return (
    <DrawerRight
      open={!!reorderIds}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-skin'>
        <h6 className="v-content-label">Reorder Categories</h6>

        {
          reorderIds &&
            <Sortable
              ids={reorderIds}
              onClickSave={onClickSave}
              items={categories}
              titleKey='title'
              imageKey='image_url'
            />
        }
      </div>
    </DrawerRight>
  )
}

export default Reorder;
